<template>
  <div class="container">
    <van-nav-bar title="提交结果" left-text="" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <van-steps direction="vertical" :active="active" active-color="#38f" class="mg12">
      <van-step>
        <p>已提交单据</p>
      </van-step>
      <van-step>
        <p>等待平台审核</p>
      </van-step>
      <van-step>
        <p>审核通过</p>
      </van-step>
    </van-steps>
    <div class="mg12">
      <van-field readonly label="抄表项目：" :value="communityName" />
      <van-field readonly label="单据数量：" :value="fileNum" />
    </div>

    <div class="btnbox">
      <van-button type="info" size="large" @click="changePage">完成</van-button>
    </div>
    
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Button,Field,Step, Steps} from 'vant';
  export default {
    data() {
      return {
        active: 0,
        fileNum:'',
        communityName: '',
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Button.name]:Button,
      [Field.name]:Field,
      [Step.name]:Step,
      [Steps.name]:Steps,
    },
    methods: {
      changePage(){
        this.$router.replace({path: "home.html"});
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      onClickRight() {
        // this.$router.push({path: "search.html",query:{pageType: 3}});
      },
    },
    computed:{
    },
    created () {
      this.active = this.$route.query.active;
      this.fileNum = this.$route.query.fileNum;
      this.communityName = this.$route.query.communityName;
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #fff;
  }
  .btnbox{
    margin-top: 100px;
    padding: 0 50px;
  }
  .mg12{margin-top: 12px;}
  
</style>
